module.exports = "mutation product($product:ProductInput!){saveProduct(product:$product){id}}"